import { all } from "redux-saga/effects";

import auth from "./auth";
import reportData from "./reportData";

export default function* rootSaga() {
  return yield all([auth(), reportData()]);
}
